export default __webpack_public_path__ + "static/homepage-d3764c181b851e48d56e18c8532380df.mp4";